import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { useConditionRefinementChange } from '../../hooks/useConditionRefinementChange';
import EditorConditionBase from './EditorConditionBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionRefinements = props => {
  const {
    condition,
    filterFamily,
    onConditionChange,
    dateRefinement,
    numberRefinement,
    inputUse
  } = props;
  const {
    onRefinementDelete: onDateRefinementDelete,
    onRefinementOperatorChange: onDateRefinementOperatorChange,
    onRefinementValueChange: onDateRefinementValueChange
  } = useConditionRefinementChange(filterFamily, condition, onConditionChange, PropertyTypes.DATE);
  const {
    onRefinementDelete: onNumberRefinementDelete,
    onRefinementOperatorChange: onNumberRefinementOperatorChange,
    onRefinementValueChange: onNumberRefinementValueChange
  } = useConditionRefinementChange(filterFamily, condition, onConditionChange, PropertyTypes.NUMBER);
  if (!dateRefinement && !numberRefinement) {
    return null;
  }
  const dateRefinementWithErrors = dateRefinement && dateRefinement.set('errors', dateRefinement.errors.concat(condition.errors.filter(error => error.get('opts') && error.get('opts').isRefinement)));
  const numberRefinementWithErrors = numberRefinement && numberRefinement.set('errors', numberRefinement.errors.concat(condition.errors.filter(error => error.get('opts') && error.get('opts').isRefinement)));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [dateRefinementWithErrors && /*#__PURE__*/_jsx(EditorConditionBase, {
      condition: dateRefinementWithErrors,
      filterFamily: filterFamily,
      onConditionDelete: onDateRefinementDelete,
      onConditionOperatorChange: onDateRefinementOperatorChange,
      onConditionValueChange: onDateRefinementValueChange,
      inputUse: inputUse
    }), numberRefinementWithErrors && /*#__PURE__*/_jsx(EditorConditionBase, {
      condition: numberRefinementWithErrors,
      filterFamily: filterFamily,
      onConditionDelete: onNumberRefinementDelete,
      onConditionOperatorChange: onNumberRefinementOperatorChange,
      onConditionValueChange: onNumberRefinementValueChange,
      inputUse: inputUse
    })]
  });
};
export default EditorConditionRefinements;